import { FC } from 'react';

import CustomIcon from '@components/utils/CustomIcon';
import { BaseCheckIcon } from '@assets/icons';

import { HighLightGroupProps } from './HighLightGroupInterface';
import {
  HighlightItem,
  HighLightItemContainer,
  HighlightItemDot,
} from './HighLightGroupStyle';

const HighLightGroup: FC<HighLightGroupProps> = (props) => {
  const { listing, highLights, ...otherProps } = props;

  return (
    <HighLightItemContainer {...otherProps}>
      {highLights &&
        Array.isArray(highLights) &&
        highLights?.map((h) => (
          <HighlightItem key={h} {...props}>
            {listing ? (
              <CustomIcon
                paletteColor='primaryBrand'
                icon={BaseCheckIcon}
                fontSize={18}
              />
            ) : (
              <HighlightItemDot>.</HighlightItemDot>
            )}
            <span>{h}</span>
          </HighlightItem>
        ))}
    </HighLightItemContainer>
  );
};

export default HighLightGroup;
